export const getDevice = (): string => {
  const userAgent = navigator.userAgent;

  if (/Windows NT/.test(userAgent)) {
    return 'Windows PC';
  } else if (/Macintosh/.test(userAgent)) {
    return 'Mac';
  } else if (/Linux/.test(userAgent)) {
    return 'Linux PC';
  } else if (/Android/.test(userAgent)) {
    return 'Android Device';
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    return 'iPhone/iPad';
  }

  return 'Unknown Device';
};
